import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

import { bgLinearGradient } from "@/app/types/ui";
import { MimiatHorizontalLogo } from "@/components/shared/MimiatHorizonalLogo";
import { HeadingOne } from "@/components/ui/typography/HeadingOne";
import { HeadingTwo } from "@/components/ui/typography/HeadingTwo";
import { Paragraph } from "@/components/ui/typography/Paragraph";

import newPasswordImg from "@/assets/reset-password/new-password.svg";
import { NewPasswordForm } from "@/components/reset-password/NewPasswordForm";

export const Route = createFileRoute("/reset-password/new")({
  component: NewPassword,
});

function NewPassword() {
  const { t } = useTranslation();

  return (
    <div className="grid grid-cols-5 min-h-screen overflow-hidden">
      {/* Image */}
      <div className="grid col-span-2 bg-beige self-center overflow-hidden">
        <div className="flex flex-col gap-4 items-center">
          <img
            src={newPasswordImg}
            alt={t("new_password.img_alt")}
            className="w-3/5 h-auto"
          />
          <div className="flex flex-col gap-4 text-center mx-8">
            <HeadingTwo>{t("new_password.msg_title")}</HeadingTwo>
            <Paragraph>{t("new_password.msg_text")}</Paragraph>
          </div>
        </div>
      </div>

      {/* New Password Form */}
      <div
        className={`grid col-span-3 ${bgLinearGradient} border-l-1 border-neutral-500 overflow-y-auto h-screen`}
      >
        <div className="flex flex-col my-16 justify-center">
          <div className="mx-auto mb-14">
            <MimiatHorizontalLogo />
          </div>
          <div className="mx-24 2xl:min-w-[575px] 2xl:mx-auto">
            <div className="flex flex-col gap-2 mb-4">
              <HeadingOne>{t("new_password.title")}</HeadingOne>
              <Paragraph>{t("new_password.subtitle")}</Paragraph>
            </div>
            <NewPasswordForm />
          </div>
        </div>
      </div>
    </div>
  );
}
